module.exports = __webpack_public_path__ + "img/Arrow_up.4edc8aeb.svg";